import React from 'react'
import PropTypes from 'prop-types'
import {StyledH1, StyledH2, StyledH3, StyledH4, StyledH5, StyledH6} from './Heading.styled'

export const HeadingSizeEnum = Object.freeze({
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
})

const Heading = (props) => {
  const {label, size, className, id} = props
  switch (size) {
    case HeadingSizeEnum.h1:
      return <StyledH1 id={id} className={className}>{label}</StyledH1>
    case HeadingSizeEnum.h2:
      return <StyledH2 id={id} className={className}>{label}</StyledH2>
    case HeadingSizeEnum.h3:
      return <StyledH3 id={id} className={className}>{label}</StyledH3>
    case HeadingSizeEnum.h4:
      return <StyledH4 id={id} className={className}>{label}</StyledH4>
    case HeadingSizeEnum.h5:
      return <StyledH5 id={id} className={className}>{label}</StyledH5>
    case HeadingSizeEnum.h6:
      return <StyledH6 id={id} className={className}>{label}</StyledH6>
    default:
      return <StyledH2 id={id} className={className}>{label}</StyledH2>
  }
}

Heading.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  size: PropTypes.string,
}

export default Heading
